import { useState } from 'react';
import { Group, Box, Collapse, ThemeIcon, Text, UnstyledButton, rem } from '@mantine/core';
import { IconCalendarStats, IconChevronRight } from '@tabler/icons-react';
import classes from './NavbarLinksGroup.module.css';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mantine/hooks';

interface LinksGroupProps {
  icon: React.FC<any>;
  label: string;
  link?: string;
  initiallyOpened?: boolean;
  links?: { label: string; link: string }[];
}

export function LinksGroup({ icon: Icon, label, initiallyOpened, links, link }: LinksGroupProps) {
  const navigate = useNavigate();

  const hasLinks = Array.isArray(links);
  const [opened, setOpened] = useState(initiallyOpened || false);
  const items = (hasLinks ? links : []).map((link) => (
    <Text<'a'>
      component="a"
      className={classes.link}
      href={link.link}
      key={link.label}
      onClick={(event) => {
        event.preventDefault();
        navigate(link.link);
      }}
    >
      {link.label}
    </Text>
  ));

  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <>
      <UnstyledButton
        onClick={() => {
          if (link) navigate(link);
          else setOpened((o) => !o);
        }}
        className={classes.control}
        style={{
          cursor: `${link || links ? 'cursor' : 'not-allowed'}`,
          paddingLeft: isMobile ? '0' : '',
        }}
      >
        <Group justify={isMobile ? 'flex' : 'space-between'} gap={2}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <ThemeIcon
              // variant={link || links ? 'light' : 'default'}
              variant="light"
              size={isMobile ? 50 : 30}
              color={link || links ? '' : 'gray'}
            >
              <Icon style={{ width: rem(18), height: rem(18) }} />
            </ThemeIcon>
            {link ? (
              <Box<'a'>
                ml="md"
                component="a"
                href={link}
                key={label}
                onClick={(event) => {
                  event.preventDefault();
                }}
                style={{
                  textDecoration: 'none',
                  color: 'var(--mantine-color-text)',
                  fontSize: isMobile
                    ? 'var(--mantine-font-size-md)'
                    : 'var(--mantine-font-size-sm)',
                }}
              >
                {label}
              </Box>
            ) : (
              <Box ml="md">
                <Text color={links ? 'current' : 'gray'} size={isMobile ? 'md' : 'sm'}>
                  {label}
                </Text>
              </Box>
            )}
          </Box>
          {hasLinks && (
            <IconChevronRight
              className={classes.chevron}
              stroke={1.5}
              style={{
                width: rem(16),
                height: rem(16),
                transform: opened ? 'rotate(-90deg)' : 'none',
              }}
            />
          )}
        </Group>
      </UnstyledButton>
      {hasLinks ? <Collapse in={opened}>{items}</Collapse> : null}
    </>
  );
}

const mockdata = {
  label: 'Releases',
  icon: IconCalendarStats,
  links: [
    { label: 'Upcoming releases', link: '/' },
    { label: 'Previous releases', link: '/' },
    { label: 'Releases schedule', link: '/' },
  ],
};

export function NavbarLinksGroup() {
  return (
    <Box mih={220} p="md">
      <LinksGroup {...mockdata} />
    </Box>
  );
}
